/**
 * CDAV Library
 *
 * This library is part of the Nextcloud project
 *
 * @author Georg Ehrke
 * @copyright 2018 Georg Ehrke <oc.list@georgehrke.com>
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU AFFERO GENERAL PUBLIC LICENSE
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU AFFERO GENERAL PUBLIC LICENSE for more details.
 *
 * You should have received a copy of the GNU Affero General Public
 * License along with this library.  If not, see <http://www.gnu.org/licenses/>.
 *
 */

export const DAV = 'DAV:';
export const IETF_CALDAV = 'urn:ietf:params:xml:ns:caldav';
export const IETF_CARDDAV = 'urn:ietf:params:xml:ns:carddav';
export const OWNCLOUD = 'http://owncloud.org/ns';
export const NEXTCLOUD = 'http://nextcloud.com/ns';
export const APPLE = 'http://apple.com/ns/ical/';
export const CALENDARSERVER = 'http://calendarserver.org/ns/';
export const SABREDAV = 'http://sabredav.org/ns';

export const NS_MAP = {
	d: DAV,
	cl: IETF_CALDAV,
	cr: IETF_CARDDAV,
	oc: OWNCLOUD,
	nc: NEXTCLOUD,
	aapl: APPLE,
	cs: CALENDARSERVER,
	sd: SABREDAV
};

/**
 * maps namespace like DAV: to it's short equivalent
 *
 * @param {String} short
 * @returns {String}
 */
export function resolve(short) {
	return NS_MAP[short] || null;
}
